import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/components/Landing";
import AdminApplications from "@/pages/AdminApplications";
import MemberDashboard from "@/pages/MemberDashboard";
import MemberHome from "@/pages/MemberHome";
import MemberProfile from "@/pages/MemberProfile";
import MemberProfileOverview from "@/pages/MemberProfileOverview";
import ServiceRequestForm from "@/pages/ServiceRequestForm";
import SetPassword from "@/pages/SetPassword";
import { Support, Privacy } from "@/pages/Legal";
import { AuthProvider } from "@/context/AuthContext";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin" element={<AdminApplications />} />
            <Route path="/member" element={<MemberHome />} />
            <Route path="/member/profile" element={<MemberProfileOverview />} />
            <Route path="/member/profile/edit" element={<MemberProfile />} />
            <Route path="/member/history" element={<MemberDashboard />} />
            <Route path="/member/request" element={<ServiceRequestForm />} />
            <Route path="/set-password" element={<SetPassword />} />
            <Route path="/support" element={<Support />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
